import { render, staticRenderFns } from "./RxInfo.vue?vue&type=template&id=d7dfdb1e"
import script from "./RxInfo.vue?vue&type=script&lang=js"
export * from "./RxInfo.vue?vue&type=script&lang=js"
import style0 from "./RxInfo.vue?vue&type=style&index=0&id=d7dfdb1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports